import { defineStyleConfig, StyleFunctionProps } from '@chakra-ui/react';

const Input = defineStyleConfig({
    sizes: {
        sm: {
            field: {
                h: {
                    base: '40px',
                    sm: '40px',
                    md: '60px',
                    lg: '60px'
                },
                py: '20px',
                fontSize: '16px',
                lineHeight: '28px',
            },
        },
        md: {
            field: {
                h: {
                    base: '40px',
                    sm: '40px',
                    md: '60px',
                    lg: '60px'
                },
                py: '20px',
                fontSize: '16px',
                lineHeight: '28px',
            },
        },
        lg: {
            field: {
                h: {
                    base: '60px',
                    sm: '60px',
                    md: '60px',
                    lg: '60px'
                },
                py: '20px',
                fontSize: '16px',
                lineHeight: '28px',
            },
        },
    },
    variants: {
        primary: (props: StyleFunctionProps) => ({
            field: {
                bg: props.colorMode === 'light' ? 'white' : 'alphaWhite01',
                outline: 'none',
                border: '1px',
                borderColor:
                    props.colorMode === 'light' ? 'border' : 'transparent',
                borderRadius: '10px',
                color: props.colorMode === 'light' ? 'navy' : 'white',
                _placeholder: {
                    color: props.colorMode === 'light' ? 'navy' : 'white',
                    transition: 'opacity 0.2s ease-in-out',
                },
                _focus: {
                    _placeholder: {
                        opacity: 0,
                    },
                },
            },
        }),
    },
    defaultProps: {
        size: 'md',
        variant: 'primary',
    },
});
export default Input;
